module.exports = __webpack_public_path__ + "img/department_icon2.e575839f.png";